import React from 'react'

function HowToDoIt() {

    const howToDoIt = [
        "Acesse o aplicativo BMG ou ligue para a central de atendimento.",
        "Escolha a opção “Saque do limite do cartão consignado”.",
        "Informe o valor que deseja sacar.",
        "O dinheiro cai na sua conta em até 1 dia útil.",
        "Pague o valor sacado na fatura do cartão."
    ];

    return (
        <section id='HowToDoIt' className="max-w-4xl mx-auto py-10 px-6">
            <h2 className="text-2xl font-bold text-gray-800 text-center mb-6">📌 Como fazer o saque?</h2>
            <ol className="list-decimal list-inside space-y-3 text-gray-700">
                {howToDoIt.map((passo, index) => (
                    <li key={index} className="text-lg">{passo}</li>
                ))}
            </ol>
        </section>
    )
}

export default HowToDoIt